var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BannerCarousel from '../BannerCarousel/BannerCarousel';
var HeroBanner = function (_a) {
    var _b, _c;
    var banners = _a.banners, bannerName = _a.bannerName, actions = _a.actions, allowedPaths = _a.allowedPaths, _d = _a.handleBannerActions, handleBannerActions = _d === void 0 ? true : _d;
    var _e = useState(false), pageLoaded = _e[0], setPageLoaded = _e[1];
    var location = useLocation();
    var isPathAllowed = allowedPaths.includes(location.pathname);
    var hasBannerData = ((_b = banners === null || banners === void 0 ? void 0 : banners[bannerName]) === null || _b === void 0 ? void 0 : _b.length) >= 0;
    var showBanner = isPathAllowed && ((_c = banners === null || banners === void 0 ? void 0 : banners[bannerName]) === null || _c === void 0 ? void 0 : _c.length) > 0;
    useEffect(function () {
        function fetchData() {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!!pageLoaded) return [3 /*break*/, 3];
                            if (!(handleBannerActions && !hasBannerData)) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = actions === null || actions === void 0 ? void 0 : actions.bannerActions) === null || _a === void 0 ? void 0 : _a.getBanners(bannerName))];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2:
                            setPageLoaded(true);
                            _b.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        fetchData();
        return function () {
            setPageLoaded(false);
        };
    }, []);
    if (showBanner) {
        return (_jsx("div", { className: 'hero-carousel d-block', children: _jsx(BannerCarousel, { banners: banners, bannerName: bannerName }) }));
    }
    else {
        return null;
    }
};
export default HeroBanner;
